module.exports = __webpack_public_path__ + "media/fundraising_sim/plus_img-sp01-36e04315.png";